import 'twin.macro';
import React, { useState } from 'react';
import { useEleveCount } from '@teetsh/app/src/queries/eleves/useEleves';
import { Outlet, useLocation } from 'react-router-dom';
import useElevesViews from '@teetsh/app/src/queries/eleves/views/useElevesViews';
import SchoolyearRedirect from '@teetsh/app/src/components/Redirect/SchoolyearRedirect';
import { getQueryString } from '@teetsh/app/src/containers/App/ParamsExtractor/getQueryString';
import { PageTrackerWrapper } from 'queries/user/track';

export function ElevesList() {
  const { data: nbOfEleves, isLoading, isSuccess } = useEleveCount();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState<boolean>(
    !!getQueryString(location)?.open || false,
  );
  const {
    data: views,
    isLoading: isLoadingViews,
    isSuccess: isSuccessViews,
  } = useElevesViews();
  const isReady = !isLoading && isSuccess && !isLoadingViews && isSuccessViews;
  if (isReady && nbOfEleves === 0 && !isOpen) {
    return <SchoolyearRedirect to={'eleves/import'} />;
  }
  return (
    <PageTrackerWrapper title="Élèves - liste">
      <Outlet
        context={{
          isOpen,
          setIsOpen,
          views: views || [],
          isReady,
        }}
      />
    </PageTrackerWrapper>
  );
}
